// Official brand logos — use exactly as provided, no modifications.
export const LOGOS = {
  // Soul Trip painted wordmark — locally processed, FULLY transparent PNG
  // (alpha-keyed from the official artwork, no canvas/box/checkerboard).
  // Only the brush-stroke "SOUL TRIP" lettering + mountain peaks. Native AR ≈ 2.93:1.
  soulTripMark: "/soultrip-wordmark.png",
  // Soul Trip "A WIN Exclusive Show" full poster
  soulTripWinPoster:
    "https://customer-assets.emergentagent.com/job_virtual-journey-hub-1/artifacts/bdyrc8gu_ChatGPT%20Image%20Jun%2025%2C%202026%2C%2001_25_00%20PM.png",
  gandabherunda:
    "https://customer-assets.emergentagent.com/job_virtual-journey-hub-1/artifacts/s1xbrqsi_Gandabherunda%20logo.png",
  etvWin:
    "https://customer-assets.emergentagent.com/job_virtual-journey-hub-1/artifacts/lgntlirg_WIN-LOGO-FINAL%20%281%29.PNG",
  rizwanTamada:
    "https://customer-assets.emergentagent.com/job_virtual-journey-hub-1/artifacts/w8xu23wb_Rizwan-entertainments-presents-logo-%2B-tamada-%20%281%29.png",
  kMusic:
    "https://customer-assets.emergentagent.com/job_virtual-journey-hub-1/artifacts/44v8ld88_K%20Music%20-%20Logo.png",
  // TV9 Telugu — official broadcasting partner logo
  tv9:
    "https://customer-assets.emergentagent.com/job_virtual-journey-hub-1/artifacts/3ubs6i2u_tv9%20Logo.png",
  // Season 1 official end-card poster (cinematic wrap art with full crew credits)
  s1EndCard:
    "https://customer-assets.emergentagent.com/job_virtual-journey-hub-1/artifacts/4kwup6aa_SOUL%20TRIP%20End%20Card.jpg.jpeg",
};

// ETV Win — official Soul Trip series page (default destination for every "Watch Full Episode" button)
export const ETV_WIN_SERIES_URL = "https://www.etvwin.com/series/soul-trip/No27k22XE8";

// Official social handles
export const SOCIALS = {
  instagram: "https://www.instagram.com/gandabherundaarts/",
  youtube: "https://youtube.com/@soultrip-talks",
};
